import { request } from "services/request";

const resource = "api/featureModules";

const getInitialSettingsList = () => request(`${resource}/getInitialSettingsList`, { method: "GET" });

export { getInitialSettingsList };
